import { ColumnProps } from 'antd/lib/table'
import KTable from 'app/components/Modules/Table/_KTable'
import { TableProps } from 'app/constants/GlobalTypes'
import { normalizeProject } from 'app/lib/apollo/normalizers/Project'
import { applyPaginatedNormalizer } from 'app/lib/apollo/normalizers/utilities'
import useTranslation from 'app/lib/hooks/useTranslation'
import { RecordTypeEnum } from 'app/queries'
import * as React from 'react'

import ProjectEmpty, { ProjectEmptySearch } from './Empty'
import Item from './Mobile/Item'
import ProjectStageTag from './StageTag'

const ProjectTable: React.FC<TableProps<IProject>> = ({ params, extraColumns = [], ...others }) => {
  const { tCore, tAttribute } = useTranslation({
    scope: 'table',
    recordType: RecordTypeEnum.project
  })

  const columns: ColumnProps<IProject>[] = [
    {
      title: tAttribute({ id: 'name' }),
      dataIndex: 'name',
      key: 'projects.name',
      ellipsis: true,
      width: 150
    },
    {
      title: tAttribute({ id: 'start_date' }),
      dataIndex: 'start_date',
      key: 'projects.start_date',
      ellipsis: true,
      width: 150
    },
    {
      title: tAttribute({ id: 'end_date' }),
      dataIndex: 'end_date',
      ellipsis: true,
      width: 150
    },
    {
      title: tAttribute({ id: 'status' }),
      dataIndex: 'stage',
      key: 'projects.stage',
      ellipsis: true,
      width: 150,
      render: (_, project) => <ProjectStageTag member={project} />
    },
    {
      title: tCore({ id: 'location' }),
      dataIndex: 'city',
      key: 'address',
      ellipsis: true,
      width: 150,
      fixed: 'right',
      render: (_, project: IProject) => project.address?.city
    }
  ]

  return (
    <KTable<IProject>
      recordType={RecordTypeEnum.project}
      params={params}
      columns={[...columns, ...extraColumns]}
      showSearch
      queryOptions={{
        normalizer: (data) =>
          applyPaginatedNormalizer({
            data,
            normalizer: normalizeProject,
            recordType: RecordTypeEnum.project
          })
      }}
      renderMobileRow={(record: IProject) => <Item member={record} />}
      empty={{
        emptySearchText: <ProjectEmptySearch />,
        default: <ProjectEmpty />
      }}
      {...others}
    />
  )
}

export default ProjectTable
